import { SwiperSlide } from "swiper/react";
import useTranslation from "next-translate/useTranslation";
import Slider from "@/components/common/Slider";
import AboutCard from "@/components/become-consultant/AboutCard";

const WhyVialantis = ({ whyVialantis = [] }) => {
  const { t } = useTranslation("become-consultant");

  return (
    <section className="container lg:py-16 pt-16 pb-4">
      <h2 className="text-xl lg:text-4xl font-semibold text-center">{t`why-vialantis.title`}</h2>
      <p className="mt-2 lg:mt-3 text-xs lg:text-base text-center text-grey-700">{t`why-vialantis.subtitle`}</p>
      <div className="lg:mt-12">
        <Slider>
          {whyVialantis.map((about) => (
            <SwiperSlide key={about.id} className="py-4 lg:py-8 !h-auto">
              <AboutCard about={about} />
            </SwiperSlide>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default WhyVialantis;
